export const Close = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5831 4.25004L15.7498 2.41675L9.99982 8.25008L4.2498 2.41675L2.4165 4.25004L8.24984 10.0001L2.4165 15.7501L4.2498 17.5834L9.99982 11.75L15.7498 17.5834L17.5831 15.7501L11.7498 10.0001L17.5831 4.25004Z"
      fill="currentColor"
    />
  </svg>
);
